import { Text } from "@repo/skapa";
import { t } from "@repo/translation";
import { Label } from "@repo/ui";

interface LabelLinkFieldProps {
  label: string;
  link?: string;
}
export const LabelLinkField = ({ label, link }: LabelLinkFieldProps) => (
  <div>
    <Label label={label} bold />
    {link ? (
      <a
        href={link}
        style={{ textDecoration: "underline" }}
        target="_blank"
        rel="noreferrer"
      >
        {t("action.open_link")}
      </a>
    ) : (
      <Text>-</Text>
    )}
  </div>
);
